var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12 16",
    style: {
      enableBackground: "new 0 0 12 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5,6.5C6.5,6.2,6.3,6,6,6C5.7,6,5.5,6.2,5.5,6.5v3.8L4.4,9.1C4.2,9,3.8,9,3.6,9.1s-0.2,0.5,0,0.7l2,2 c0.2,0.2,0.5,0.2,0.7,0c0,0,0,0,0,0l2-2c0.2-0.2,0.2-0.5,0-0.7S7.8,9,7.6,9.1l-1.1,1.1V6.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12,14V4.5L7.5,0H2C0.9,0,0,0.9,0,2v12c0,1.1,0.9,2,2,2h8C11.1,16,12,15.1,12,14z M7.5,3c0,0.8,0.7,1.5,1.5,1.5h2V14 c0,0.6-0.4,1-1,1H2c-0.6,0-1-0.4-1-1V2c0-0.6,0.4-1,1-1h5.5V3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.fed724c849f9c226375a0ca290de5a2e.svg";
export { ForwardRef as ReactComponent };